import { render, staticRenderFns } from "./LanguageMenu.vue?vue&type=template&id=01c61dd7&scoped=true&"
import script from "./LanguageMenu.vue?vue&type=script&lang=js&"
export * from "./LanguageMenu.vue?vue&type=script&lang=js&"
import style0 from "./LanguageMenu.vue?vue&type=style&index=0&id=01c61dd7&prod&lang=scss&scoped=true&"
import style1 from "./LanguageMenu.vue?vue&type=style&index=1&id=01c61dd7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c61dd7",
  null
  
)

export default component.exports